
import React from 'react'
import Calendar from 'react-calendar';
import { useSelector } from 'react-redux';
import { SaleRegister } from '../../../../assets/icons'
import { Translate } from '../../../../language'
import Input from '../../../../utils/components/Input/Input';
import TitleSVG from '../../../../utils/components/TitleSVG/TitleSVG'
import useModal from '../../../../utils/hooks/useModal'
import style from './ReportByType.module.css'
const ReportByType = ({
    type,
    setType,
    dateStart,
    setDateStart,
    dateEnd,
    setDateEnd
}) => {
    const [refStart, isShowStart, setIsShowStart] = useModal(false)
    const [refEnd, isShowEnd, setIsShowEnd] = useModal(false)
    const { productMoreOrLessSaled } = useSelector(state => state.inventory)
    return (
        <div>
            <TitleSVG Icon={SaleRegister} titleHighlight={Translate('inventoryReportByType', 'es').split(/ (.*)/s,2)[0]} title={" "+Translate('inventoryReportByType', 'es').split(/ (.*)/s,2)[1]} />
            <div>
                <div>
                    {productMoreOrLessSaled.product &&
                        <div>
                            <div>
                                <strong>Producto</strong> {productMoreOrLessSaled.product.name}
                            </div>
                            <div>
                                <strong>Cantidad vendida</strong>   {productMoreOrLessSaled.orderedQuantity}
                            </div>
                            <div>
                                <strong>Costo de producion</strong> {productMoreOrLessSaled.product.productCost}
                            </div>
                        </div>
                    }

                </div>
                <div className={style.dates_container}>
                    <div>
                        <select className='input-select-style' name="type" value={type} onChange={(e) => setType(e.target.value)}>
                            <option value="">Seleccione</option>
                            <option value="mostSold">Mas vendido</option>
                            <option value="leastSold">Menos vendido</option>
                        </select>
                    </div>
                    <Input placeholder='Fecha inicial'
                        readOnly
                        value={dateStart.toLocaleDateString()}
                        onClick={() => setIsShowStart(true)}
                    />
                    <div ref={refStart} >
                        {isShowStart &&
                            <div

                                style={{
                                    display: isShowStart ? 'block' : 'none'
                                }}
                                className="modal calendar-register" >
                                <Calendar
                                    maxDate={dateEnd}
                                    onChange={(dateTime) => {
                                        setDateStart(new Date(dateTime))
                                        setIsShowStart(false)
                                    }
                                    }
                                />
                            </div>
                        }
                    </div>

                    <Input placeholder='Fecha final'
                        readOnly
                        value={dateEnd.toLocaleDateString()}
                        onClick={() => setIsShowEnd(true)}
                    />
                    <div ref={refEnd} >
                        {isShowEnd &&
                            <div

                                style={{
                                    display: isShowEnd ? 'block' : 'none'
                                }}
                                className="modal calendar-register" >
                                <Calendar
                                    minDate={dateStart}
                                    maxDate={new Date()}
                                    onChange={(dateTime) => {
                                        setDateEnd(new Date(dateTime))
                                        setIsShowEnd(false)
                                    }
                                    }
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportByType